<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Usuários</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="">Unidade</label>
									<select-unidade
										:tipo="TIPO_CONTRATO.PRESTADOR"
										@setUnidadeSelecionada="
											(unidadeSelecionada) => {
												setUnidadeSelecionada(
													unidadeSelecionada
												);
											}
										"
									></select-unidade>
								</div>
							</div>
							<div class="col-md-3">
								<div
									:class="{
										'form-group': true,
										'has-error': errors.has('nivel'),
									}"
								>
									<label for="nivel">Perfil:</label>
									<select
										class="form-control"
										name="nivel"
										type="text"
										v-model="filtros.nivel"
									>
										<option value>--Selecione--</option>
										<option value="administrador">
											Administrador
										</option>
										<option value="regulador">
											Regulador
										</option>
										<option value="marcador">
											Marcador
										</option>
										<option value="prestador">
											Prestador
										</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<div
									:class="{
										'form-group': true,
										'has-error': errors.has('situacao'),
									}"
								>
									<label for="situacao">Situação:</label>
									<select
										class="form-control"
										name="situacao"
										type="text"
										v-model="filtros.situacao"
									>
										<option value>--Selecione--</option>
										<option value="1">Ativo</option>
										<option value="0">Inativo</option>
									</select>
								</div>
							</div>
						</div>

						<div class="box-footer text-right" ref="filtrar">
							<button
								class="btn btn-info"
								@click.self.prevent="getPDF"
								v-if="pdf"
							>
								Recarregar PDF
								<span
									class="fa fa-file-pdf-o"
									aria-hidden="true"
								></span>
							</button>
							<button
								@click="getDataTable()"
								data-toggle="tooltip"
								title="Pesquisar Relatório de Usuários"
								class="btn btn-primary"
								:disabled="finalizado"
							>
								<span class="fa fa-search"></span> Pesquisar
							</button>
						</div>
						<div v-if="pdf">
							<embed
								type="application/pdf"
								:src="pdf"
								width="100%"
								:height="heigthPdf"
							/>
						</div>
						<div class="row" style="margin-top: 15px" v-else>
							<div class="col-md-12">
								<div class="col-sm-12 table-responsive">
									<table
										aria-describedby="example1_info"
										role="grid"
										id="example1"
										class="table table-bordered table-striped"
									>
										<thead>
											<tr role="row">
												<th style="width: 17%">Nome</th>
												<th style="width: 12%">
													Usuário
												</th>
												<th style="width: 17%">
													Email
												</th>
												<th style="width: 10%">
													Nível
												</th>
												<th style="width: 20%">
													Unidades
												</th>
												<th style="width: 12%">
													Situação
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												class="even"
												role="row"
												v-for="item in dataTable.data"
												:key="item.id"
											>
												<td>{{ item.name }}</td>
												<td>{{ item.login }}</td>
												<td>{{ item.email }}</td>
												<td>{{ item.nivel }}</td>
												<td>
													{{
														item.unidades | unidades
													}}
												</td>
												<td>
													{{
														item.situacao | situacao
													}}
												</td>
											</tr>
										</tbody>
									</table>
									<div
										class="row"
										v-if="
											dataTable.data &&
											dataTable.data.length > 0
										"
									>
										<div class="col-sm-4">
											Mostrando
											{{ this.dataTable.from }} até
											{{ this.dataTable.to }} de
											{{ this.dataTable.total }} registros
											encontrados.
										</div>
										<div
											class="col-sm-6"
											style="text-align: right"
										>
											<laravue-pagination
												:data="dataTable"
												v-on:pagination-change-page="
													getDataTable
												"
											>
												<span slot="prev-nav"
													>&lt; Anterior</span
												>
												<span slot="next-nav"
													>Próximo &gt;</span
												>
											</laravue-pagination>
										</div>
										<div class="col-sm-2 text-right">
											<button
												class="btn btn-info pdf"
												:disabled="finalizado"
												@click.self.prevent="getPDF"
											>
												<span
													class="fa fa-file-pdf-o"
													aria-hidden="true"
												></span>
												PDF
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
import { TIPO_CONTRATO } from "@/constants";
import axios from "axios"; // Cliente para requisição http

export default {
	computed: {
		TIPO_CONTRATO: function () {
			return TIPO_CONTRATO;
		},
	},
	filters: {
		unidades: function (val) {
			let unidades = "";
			for (let i = 0; i < val.length; i++) {
				unidades += val[i].nome;
				if (i + 1 < val.length) {
					unidades += ", ";
				}
			}

			return unidades;
		},
		situacao: function (val) {
			if (val == 1) return "ATIVO";
			return "INATIVO";
		},
	},
	data: () => ({
		pdf: null,
		heigthPdf: 900,
		finalizado: false,
		filtros: {
			nivel: "",
			unidade_id: null,
			situacao: "",
		},
		dataTable: {},
	}),
	mounted() {},

	methods: {
		sortByKey: function (field) {
			this.filtros.coluna = field;
			if (this.filtros.ordem == "asc") {
				this.filtros.ordem = "desc";
			} else {
				this.filtros.ordem = "asc";
			}
			// this.getUsers();
		},
		getDataTable(page) {
			this.finalizado = true;
			this.pdf = null;
			if (typeof page === "undefined") {
				page = 1;
			}
			this.filtros.page = page;
			this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuth;
			config.params = this.filtros;

			axios
				.get(
					`${this.$store.state.serverURI}/api/relatorios/usuarios`,
					config
				)
				.then((response) => {
					this.dataTable = response.data;
					this.$store.commit("TOGGLE_LOADING");
					this.finalizado = false;
				})
				.catch((error) => {
					this.$store.commit("throwException", error);
					this.finalizado = false;
				});
		},
		getPDF() {
			this.finalizado = true;
			this.$store.commit("TOGGLE_LOADING");
			let config = this.$store.getters.getHeaderAuthFile;
			config.params = this.filtros;
			axios
				.get(
					`${this.$store.state.serverURI}/api/relatorios/usuariosImprimir`,
					config
				)
				.then((response) => {
					this.$store.commit("TOGGLE_LOADING");
					const file = new Blob([response.data], {
						type: "application/pdf",
					});
					const fileURL = window.URL.createObjectURL(file);
					this.pdf = fileURL;
					let self = this;
					this.heigthPdf = window.innerHeight - 65;
					console.log(window.innerHeight);
					setTimeout(function () {
						self.$refs.filtrar.scrollIntoView();
					}, 300);
					this.finalizado = false;
				})
				.catch((error) => {
					this.$store.commit("throwException", error);
					this.finalizado = false;
				});
		},
		setUnidadeSelecionada(unidadeSelecionada) {
			this.filtros.unidade_id = unidadeSelecionada.id;
		},
	},
	watch: {
		page: function (val) {
			this.getDataTable();
		},
	},

	components: {
		selectUnidade,
	},
};
</script>

<style scoped>
.pdf {
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// index.vue?2dcb2b31